import React from "react";
import { Container, Navbar, NavbarBrand, Nav, Image } from "react-bootstrap";
import NavbarCollapse from "react-bootstrap/esm/NavbarCollapse";
import NavbarToggle from "react-bootstrap/esm/NavbarToggle";
import { NAVBAR_ABOUT_US, NAVBAR_CONTACTS, NAVBAR_OUR_CUSTOMERS, NAVBAR_OUR_TEAM } from "../Contexts/config";

export const NavbarSection = ({lang}) => {

    return (
        <Navbar style={{background: "linear-gradient(-270deg, #1a2c28, #2e443e)"}} expand={"lg"} variant="dark" sticky={"top"} className="p-3">
            <Container>
                <NavbarBrand className="theme-yellow-color" style={{fontSize: 35}} href="#"><Image fluid width={80} src="assets/logo-plain.png" alt="" /> Themis Legal</NavbarBrand>
                <NavbarToggle aria-controls="navbar-collapse" />
                <NavbarCollapse id="navbar-collapse">
                    <Nav className="w-75 justify-content-around">
                        <Nav.Link href="#about">{NAVBAR_ABOUT_US[lang]}</Nav.Link>
                        {/*<Nav.Link href="#team">{NAVBAR_OUR_TEAM[lang]}</Nav.Link>*/}
                        <Nav.Link href="#customers">{NAVBAR_OUR_CUSTOMERS[lang]}</Nav.Link>
                        <Nav.Link href="#contacts">{NAVBAR_CONTACTS[lang]}</Nav.Link>
                    </Nav>
                    {
                        lang === "ru" ?
                        <Nav className="w-25 justify-content-end">
                            <Nav.Link href="?lang=en">EN</Nav.Link>
                            <Nav.Link href="?lang=uz">UZ</Nav.Link>
                        </Nav> : lang === "en" ?
                        <Nav className="w-25 justify-content-end">
                            <Nav.Link href="?lang=ru">RU</Nav.Link>
                            <Nav.Link href="?lang=uz">UZ</Nav.Link>
                        </Nav> : 
                        <Nav className="w-25 justify-content-end">
                            <Nav.Link href="?lang=en">EN</Nav.Link>
                            <Nav.Link href="?lang=ru">RU</Nav.Link>
                        </Nav>
                    }
                </NavbarCollapse>
            </Container>
        </Navbar>
    );
}